export const tokens = {
    // BUTTON
    'success-border': '$color-success-500',
    'button-border': 'transparent',
    'button-border-round': 200,
    // Row
    'row-padding-horizontal': 24,
    'row-padding-vertical': 12,
    'border-card-radius': 8,
};
export default tokens;
//# sourceMappingURL=tokens.js.map